/**
 * React, react redux and react localization imports
 */
import TelegramIcon from '@mui/icons-material/Telegram'
import { Button, Grid } from '@mui/material'
import { pallete } from '../../../theme'
import { AboutApplication } from './AboutApplication'
import { TranslatableTypography } from './Typography'

const contactsStyle = {
  wrapper: {
    width: '100%',
    position: 'absolute',
    bottom: 0
  },
  header: {
    '& p': {
      fontSize: '12px',
      textAlign: 'left',
      color: pallete.paperColor,
      borderBottom: '1px solid white',
      marginLeft: '10px',
      marginRight: '10px'
    }
  },
  item: {
    padding: '10px',
    textAlign: 'center'
  },
  button: {
    background: pallete.paperColor,
    color: pallete.headerColor,
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': { background: pallete.paperColor },
    borderRadius: '25px',
    width: '100%'
  },
  signature: {
    fontSize: '0.7rem',
    color: 'white',
    fontStyle: 'italic',
    marginTop: '50px',
    marginBottom: '15px'
  }
}

export const Contacts = () => {
  return (
    <Grid container sx={contactsStyle.wrapper}>
      <Grid item xs={12} sx={contactsStyle.header}>
        <TranslatableTypography>
          You can contact Česfur on telegram:
        </TranslatableTypography>
      </Grid>
      <Grid item xs={6} sx={contactsStyle.item}>
        <Button href="https://t.me/CeSFuRSecurityBot" sx={contactsStyle.button} target="_blank">
          <TelegramIcon /> Security
        </Button>
      </Grid>
      <Grid item xs={6} sx={contactsStyle.item}>
        <Button href="https://t.me/CesfurConops" sx={contactsStyle.button} target="_blank">
          <TelegramIcon /> Conops
        </Button>
      </Grid>
      <Grid item xs={6} sx={contactsStyle.item}>
        <Button href="https://t.me/Cesfur" sx={contactsStyle.button} target="_blank" >
          <TelegramIcon /> Česfur
        </Button>
      </Grid>
      <Grid item xs={6} sx={contactsStyle.item}>
        <Button href="https://t.me/+DCIf9CE-fEtkNWJk" sx={contactsStyle.button} target="_blank" >
          <TelegramIcon /> Bugs
        </Button>
      </Grid>
      <Grid item xs={12} sx={contactsStyle.item}>
        <AboutApplication />
      </Grid>
    </Grid>
  )
}
